import Component from './WorkTime.vue';

export default {
  install(Vue) {
    Vue.component('BkfIconWorkTime', Component);
  },
};
